export interface SellingCompanyWarehouseConnection {
  id: string;
  sellingCompanyWarehouseId: string;
  sellingCompanyKey: string;
  sellingCompanyName: string;
  warehouseKey: string;
  warehouseDescription: string;
  connectionId: string;
  connectionName: string;
  ipAddress: string;
  username: string;
  password: string;
  port: number;
  folder: string;
  senderName: string;
  address: string;
  client_ID: string;
  clientSecret: string;
  fileName: string;
}
